import { NavLink } from 'react-router-dom'
import React from 'react'
import { PhoneOutlined } from '@ant-design/icons'
import { routersPath } from '@router/routes-path'

export interface ITabs {
  title: JSX.Element | Element
  pages: routersPath[]
}

export const telephonyTabs: ITabs[] = [
  {
    title: (
      <NavLink to={routersPath.PHONE_OPERATOR}>
        <PhoneOutlined />
        <span>Телефония</span>
      </NavLink>
    ),
    pages: [routersPath.PHONE_OPERATOR],
  },
  {
    title: (
      <NavLink to={routersPath.TELEPHONY}>
        <PhoneOutlined />
        <span>Телефония crm</span>
      </NavLink>
    ),
    pages: [routersPath.TELEPHONY],
  },
]
